<template>
  <div class="content">
    <div class="container">
      <form method="post"
            action="#"
            class="form form--register">
        <header-logo :logo-url="globalLogoUrl" />
        <h1 v-word:layout.userData2.mainHeader />
        <section class="form__section">
          <h2 v-word:layout.userData2.subheader />
          <mailing-lists :store="store"
                         :mailingLists="loadedMailingLists"
                         :data="mldata"
                         @change="handleMlChange" />
        </section>


        <section class="form__section">
          <h2 class="form__section__title"
              v-word:layout.userData2.events.header />
          <input-split-checkbox-group :wordings-editable="wordingsEditable"
                                      :wordings="wordings"
                                      :wordings-meta="wordingsMeta"
                                      :data="formData.event_subscription"
                                      :valDef="{
                                          'press-conference': 'layout.userData2.events.option.pressConference',
                                          'sport': 'layout.userData2.events.option.sport',
                                          'setvisits': 'layout.userData2.events.option.setvisits',
                                          ':split:': '',
                                          'premiers': 'layout.userData2.events.option.premiers',
                                          'fototermines': 'layout.userData2.events.option.fototermines',
                                          'branchen-events': 'layout.userData2.events.option.branchenEvents',
                                        }"
                                      @change="inputChanged"
                                      @wordingChange="onWordingChange"
                                      @wordingCommand="runWordingCommand" />
        </section>



        <section class="form__section">
          <h2 class="form__section__title"
              v-word:layout.userData2.contactVia.header />

          <div class="form__section__wrap">
            <div class="form__section--left">
              <input-checkbox label-word="layout.userData2.contactVia.phone.label"
                              :wordings-editable="wordingsEditable"
                              :wordings="wordings"
                              :wordings-meta="wordingsMeta"
                              @wordingChange="onWordingChange"
                              @wordingCommand="runWordingCommand"
                              :data="formData.contact_via_phone"
                              @change="inputChanged" />
            </div>
            <div class="form__section--right">
              <input-checkbox label-word="layout.userData2.contactVia.post.label"
                              :wordings-editable="wordingsEditable"
                              :wordings="wordings"
                              :wordings-meta="wordingsMeta"
                              @wordingChange="onWordingChange"
                              @wordingCommand="runWordingCommand"
                              :data="formData.contact_via_address"
                              @change="inputChanged" />
            </div>
          </div>

        </section>



        <section class="form__section">
          <p v-word:layout.userData2.midText01 />
        </section>
        <section class="form__section">

          <a class="data-policy-link"
             target="_blank"
             :href="!editMode && $router.resolve({ name: 'policy' }).href"
             v-word:layout.userData2.links.dataPolicy />

          <a class="privacy-policy-link"
             target="_blank"
             :href="!editMode && $router.resolve({ name: 'agb' }).href"
             v-word:layout.userData2.links.readPolicy />

          <input-checkbox label-word="layout.userData2.agbAccepted.label"
                          :wordings-editable="wordingsEditable"
                          :wordings="wordings"
                          :wordings-meta="wordingsMeta"
                          @wordingChange="onWordingChange"
                          @wordingCommand="runWordingCommand"
                          :data="formData.agb_accepted"
                          @change="inputChanged"
                          class="form__input--checkbox--agree"
                          downloadLink="not existent yet" />

          <input-checkbox label-word="layout.userData2.dataAccepted.label"
                          :wordings-editable="wordingsEditable"
                          :wordings="wordings"
                          :wordings-meta="wordingsMeta"
                          @wordingChange="onWordingChange"
                          @wordingCommand="runWordingCommand"
                          :data="formData.data_accepted"
                          @change="inputChanged"
                          class="form__input--checkbox--agree"
                          downloadLink="not existent yet" />

          <div class="form__input form__input--checkbox form__input--checkbox--agree">

            <input-checkbox label-word="layout.userData2.epgAccepted.label"
                            :wordings-editable="wordingsEditable"
                            :wordings="wordings"
                            :wordings-meta="wordingsMeta"
                            @wordingChange="onWordingChange"
                            @wordingCommand="runWordingCommand"
                            :data="formData.tos_accepted"
                            @change="inputChanged"
                            class="form__input--checkbox--agree"
                            downloadLink="not existent yet" />

          </div>
        </section>
        <section class="form__section">
          <div class="form__input form__input--checkbox">
            <div class="form__input__wrap">
              <label></label>
              <captcha ref="captcha"
                       @verify="token => this.formData.captcha.val = token" />
            </div>
            <p v-show="formData.captcha.error"
               class="form__error"
               v-word:validation.errors.required></p>
          </div>
        </section>
        <section class="form__section">
          <div class="form__input form__input--submit">
            <button v-on:click="submit"
                    type="submit"
                    v-word:layout.userData2.buttons.submit></button>
          </div>
          <a class="form__policy"
             target="_blank"
             :href="!editMode && $router.resolve({ name: 'policy' }).href"
             v-word:layout.userData2.links.policy />
        </section>
      </form>
    </div>
    <registration-seized-modal
      ref="registration_seized_modal"
      :wordings-editable="wordingsEditable"
      :wordings="wordings"
      :wordings-meta="wordingsMeta"
      @wordingChange="onWordingChange"
      @wordingCommand="runWordingCommand"
      :wordingsOverride="wordingsOverride" />
  </div>
</template>

<script>
import config from 'config';
import * as forms from '../utils/forms';
import wordings from '../utils/wordings';
import * as userData1 from './Registration1.vue';
import wordDirective from '../directives/word';
import mailingLists from '../components/MailingLists';
import mailingListsStorage from '../models/mailing-lists/storage.js';
import Captcha from 'ref-captcha';
import backendConfig from '../utils/backendConfig';
import registrationSeizedModal from '../modals/RegistrationSeized';
import instanceConfig from './../utils/instanceConfig';

import * as mixins from '../mixins';

export const storageName = 'userData2';
export const mailingListsStorageName = 'userData2-mailingLists';

const formDataDef = {
  agb_accepted: { '*': 1, type: 'bool' },
  data_accepted: { '*': 1, type: 'bool' },
  tos_accepted: { '*': 1, type: 'bool' },
  contact_via_phone: { '*': 1, type: 'bool' },
  contact_via_address: { '*': 1, type: 'bool' },
  event_subscription: { '*': 0 },
  captcha: { '*': 0 },
};

export default {
  props: ['store', 'editMode', 'regPassword'],
  mixins: [mixins.wordedPage, mixins.pageWithLogo, mixins.form],
  components: {
    mailingLists,
    Captcha,
    registrationSeizedModal,
  },
  data() {
    return {
      formDataDef: formDataDef,
      formStorageName: 'userData2',
      loadedMailingLists: [],
      mldata: [],
      captchaError: false,
    };
  },
  created() {
    const storedMldata = forms.withdrawFormData(mailingListsStorageName);
    if (Object.keys(storedMldata).length) {
      this.mldata = storedMldata;
    }

    !this.editMode &&
      mailingListsStorage.fetchAll(this.store.brokerData).then(mailingLists => {
        this.loadedMailingLists = mailingLists;
      });
  },
  mounted() {
    if (!this.wordingsEditable) {
      instanceConfig
        .get()
        .then(config => {
          if (config['seize-registration']) {
            this.$refs['registration_seized_modal'].open();
          }
        })
        .catch(() => {});
    }
  },
  methods: {
    handleMlChange(change) {
      if (change.id) {
        if (change.value) {
          if (!this.mldata.includes(change.id)) {
            this.mldata.push(change.id);
          }
        } else {
          const index = this.mldata.indexOf(change.id);
          if (index !== -1) {
            this.mldata.splice(index, 1);
          }
        }
        forms.persistFormData(mailingListsStorageName, this.mldata);
      }
    },
    submit(evt) {
      evt.preventDefault();

      let registrationData = forms.marshal(this.formData);
      registrationData.sso = this.store.brokerData;

      const reg1Data = forms.withdrawFormData(userData1.storageName);

      registrationData = Object.assign({}, registrationData, reg1Data);

      registrationData.mailinglists = this.mldata;

      forms.hideAllErrors(this.formData);
      this.hasErrors = false;

      registrationData.password = this.regPassword;

      this.$emit('loading');
      backendConfig.get().then(({backendUrl}) => {
        this.$http
          .post(backendUrl + config.backend.feeds.register, registrationData)
          .then(function(resp) {
            forms.clearFormData(userData1.storageName);
            forms.clearFormData(storageName);
            forms.clearFormData(mailingListsStorageName);
            this.$emit('loaded');
            this.$router.push({ path: 'registration-success' });

            this.$emit('loaded');
            if (!this.hasErrors) {
            } else {
              this.flash(this.wordings['layout.userData1.form.error'], 'error');
            }
          })
          .catch(function(resp) {
            if (resp.body.errors) {
              this.hasErrors = forms.showErrors(this.formData, resp.body.errors);

              if (typeof resp.body.errors.captcha !== 'undefined') {
                this.$refs.captcha.reset();
              }

              if (resp.status === 400 && !this.hasErrors) {
                this.$emit('autoSubmit');
                this.$router.push({ name: 'registration-1' });
              }

              if (resp.status >= 500) {
                this.flash(this.wordings['flashes.generalError'], 'error');
              }

              // if (!this.hasErrors)
            }
            this.$emit('loaded');
            if (!this.hasErrors) {
            } else {
              this.flash(this.wordings['layout.userData1.form.error'], 'error');
            }
          });
        });
        // Edge has some problems with finally
        // .finally(function() {
        //   this.$emit('loaded');
        //   if (!this.hasErrors) {
        //   }
        // });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Registration2.vue